// Deep merge function
function deepMerge(target, source) {
  const result = { ...target };

  for (const key in source) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      result[key] = deepMerge(result[key] || {}, source[key]);
    } else {
      result[key] = source[key];
    }
  }

  return result;
}

// Load configuration files from public directory
async function loadConfig() {
  // Get environment mode
  const mode = typeof __APP_MODE__ !== 'undefined' ? __APP_MODE__ : (import.meta.env.MODE || 'development');
  const isDev = import.meta.env.DEV;

  // Load default config from public directory
  const defaultConfigResponse = await fetch('/config/default.json');
  if (!defaultConfigResponse.ok) {
    throw new Error(`Failed to load default config: ${defaultConfigResponse.status}`);
  }
  const defaultConfig = await defaultConfigResponse.json();

  let envConfig = {};

  // Load environment-specific config if not development
  if (mode === 'staging' || mode === 'production' || mode === 'local-prod') {
    const envConfigResponse = await fetch(`/config/${mode}.json`);
    if (!envConfigResponse.ok) {
      throw new Error(`Failed to load ${mode} config: ${envConfigResponse.status}`);
    }
    envConfig = await envConfigResponse.json();
  }

  // Merge default with environment-specific config
  const config = deepMerge(defaultConfig, envConfig);
  if (isDev) {
    console.log('[Config] Loaded configuration for mode:', mode);
  }

  // Add some Vite-specific environment info
  config.env = {
    mode,
    isDev: import.meta.env.DEV,
    isProd: import.meta.env.PROD,
    baseUrl: import.meta.env.BASE_URL
  };

  // Helper function to get nested config values
  config.get = function (path) {
    return path.split('.').reduce((obj, key) => obj?.[key], this);
  };

  // Helper function to check if config exists
  config.has = function (path) {
    return this.get(path) !== undefined;
  };

  return config;
}

// Global config instance
let configInstance = null;

// Initialize and return config
async function initializeConfig() {
  if (!configInstance) {
    configInstance = await loadConfig();
  }
  return configInstance;
}

// Get the initialized config (throws if not initialized)
function getConfig() {
  if (!configInstance) {
    throw new Error('Configuration not initialized. Call initializeConfig() first.');
  }
  return configInstance;
}

export default getConfig;
export { loadConfig, initializeConfig, getConfig };